import { CapoPlugin } from "/home/binaffan.com/nuxt-frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];